<template>
  <div class="right-side">
    <a href="javascript:void(0);"><img src="@/assets/img/chat.png" /></a>
    <a href="javascript:void(0);"><img src="@/assets/img/qq.png" /></a>
    <a href="javascript:void(0);"><img src="@/assets/img/weixin.png" /></a>
  </div>
</template>

<script>
export default {
  name: 'RightSide',
  data() {
    return {
    };
  },
  components: {
    
  }
};
</script>

<style lang="" scoped>
.right-side{
  position: fixed;
  width: 50px;
  height: auto;
  right: 0;
  top: 70%;
  transform: translateY(-50%);
  z-index: 1000;
}

.right-side a{
  display: block;
  width: 100%;
  padding: 5px;
  background-color: #FFF;
  border: 1px solid #DDD;
  background-color: #FFF;
  text-align: center;
}

.right-side a img{
  display: inline-block;
  width: 80%
}
</style>



// WEBPACK FOOTER //
// src/pages/Layout/RightSide.vue